export class UserGroup {
  public userGroupHeaderId: number = 0;
  public addressSelectionMode: string = '';
  public assignedSalesRepEmail: string = '';
  public customerId: number = 0;
  public dateEnd: string = '';
  public dateStart: string = '';
  public defaultPurchaseOrderNumber: string = '';
  public defaultShipToId: string = '';
  public isActiveInSafestock: boolean = true;
  public isSupervisorApprovalRequired: boolean = false;
  public maximumAllowedAmount: number | null = 0;
  public minimumAmountToSkipTransportFee: number = 0; // TODO: REMOVE
  public mustHidePrices: boolean = false;
  public transportFeeAmount: number = 0; // TODO: REMOVE
  public deductTransportFeeFromBudget : boolean = false;
  public deductProductComponentFromBudget : boolean = false;
  public userGroupDescription: string = '';
  public userGroupDetails?: any = null;
  public purchaseOrderNumberSelectionMode: string = 'NotSelected';
  public orderEntrepotProductItemNumber: string = '';
  public orderEntrepotProductItemNote: string = '';
  public orderTransformationProductItemNumber: string = '';
  public orderTransformationProductItemNote: string = ''; 
  public renewalReminderRecipientEmails: string = '';
  public renewalReminderDaysBeforeExpiration: number = 0;
  public renewalReminderIsActive: boolean = false;
  public renewalReminderLastNotification: string = '';

  constructor() {
  }
}



export enum enum_POSelectionMode {
  NotSelected = "NotSelected",
  UseDefaultUserGroupValue_EmployeeCannotChange = "UseDefaultUserGroupValue_EmployeeCannotChange",
  POEnteredBySupervisor = "POEnteredBySupervisor",
  POEnteredByEmployee = "POEnteredByEmployee"
}
